import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export interface UpdatePermissionInput { id: string; resource: string; action: string; }
export function createUpdatePermissionUseCase({ membershipRepository }: Deps) {
  return async function updatePermission(input: UpdatePermissionInput): Promise<void> {
    return membershipRepository.updatePermission(input);
  };
}
